import script from "./StickersUpsellSizes.vue?vue&type=script&setup=true&lang=js"
export * from "./StickersUpsellSizes.vue?vue&type=script&setup=true&lang=js"

import "./StickersUpsellSizes.vue?vue&type=style&index=0&id=344ab096&lang=scss"

const __exports__ = script;

export default __exports__